module.exports = __webpack_public_path__ + "media/bomb.ff3e03f9.mp3";